/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Global configuration for the AI Analysis Widget visibility.
 * These act as default values. User preferences override these via local storage.
 */
export const AI_WIDGET_CONFIG = {
    enabled: false, // Disabled by default as requested
    refreshInterval: 60000, // 60 seconds default
    showOnRoutes: ['/ai-desk', '/all-markets'] // Only show on specific pages logic (handled in component)
};